import * as React from 'react';
import { Col, ControlLabel, FormControl, FormGroup, HelpBlock, Row } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import LanguageSelect from '../../components/common/LanguageSelect';
import FormSelect from '../../components/common/FormSelect';
import FieldInfoIcon from '../../components/common/FieldInfoIcon';
import FormValidationService from '../../shared/form/FormValidationService';
import CountryCodePhoneNumberInput from '../../components/common/CountryCodePhoneNumberInput';
import RoleSelect from './RoleSelect';
import IPlanEditorInput from './IPlanEditorInput';
import IPlanEditorResource from './IPlanEditorResource';

interface IPlanEditorFormProps {
    input: IPlanEditorInput;
    planFirms: IPlanEditorResource[];
    availableRoles: any[];
    onChange: (e: any) => void;
    errors: any;
    isEditMode: boolean;
    availableLanguages: any[];
}

const PlanEditorForm = (props: IPlanEditorFormProps) => {
    const { apiUrl } = window.appConfig;

    return (
        <form>
            <Row>
                <Col md={props.input.profileImageReference ? 8 : 12}>
                    <FormGroup
                        className="required"
                        validationState={FormValidationService.getValidationState(
                            props.errors.planFirmId
                        )}
                    >
                        <ControlLabel>
                            {Translate('plan-editors/form/plan-firm-select-label')}
                        </ControlLabel>
                        <FormSelect
                            name="planFirmId"
                            autoFocus
                            onChange={props.onChange}
                            value={props.input.planFirmId as any}
                            defaultTranslateKey="plan-editors/form/plan-firm-select/items/instructions"
                        >
                            {props.planFirms.map((t: any) => {
                                return (
                                    <option key={t.id} value={t.id}>
                                        {t.name}
                                    </option>
                                );
                            })}
                        </FormSelect>
                        <HelpBlock>{props.errors.planFirmId}</HelpBlock>
                    </FormGroup>

                    <RoleSelect
                        onChange={props.onChange}
                        roles={props.availableRoles}
                        role={props.input.role}
                        error={props.errors.role}
                    />

                    <FormGroup
                        className="required"
                        validationState={FormValidationService.getValidationState(
                            props.errors.name
                        )}
                    >
                        <ControlLabel>{Translate('plan-editors/form/name-label')}</ControlLabel>
                        <FormControl
                            type="text"
                            name="name"
                            value={props.input.name ? props.input.name : ''}
                            onChange={props.onChange}
                        />
                        <HelpBlock>{props.errors.name}</HelpBlock>
                    </FormGroup>
                    <FormGroup
                        className="required"
                        validationState={FormValidationService.getValidationState(
                            props.errors.username
                        )}
                    >
                        <ControlLabel>{Translate('plan-editors/form/username-label')}</ControlLabel>
                        <FormControl
                            type="text"
                            name="username"
                            value={props.input.username ? props.input.username : ''}
                            onChange={props.onChange}
                        />
                        <HelpBlock>{props.errors.username}</HelpBlock>
                    </FormGroup>
                    <FormGroup
                        className="required"
                        validationState={FormValidationService.getValidationState(
                            props.errors.email
                        )}
                    >
                        <ControlLabel>
                            {Translate('plan-editors/form/email-address-label')}
                        </ControlLabel>
                        <FormControl
                            type="email"
                            name="email"
                            value={props.input.email ? props.input.email : props.input.username}
                            onChange={props.onChange}
                        />
                        <HelpBlock>{props.errors.email}</HelpBlock>
                    </FormGroup>
                    <FormGroup
                        validationState={FormValidationService.getValidationState(
                            props.errors.phoneNumber
                        )}
                    >
                        <ControlLabel>
                            {Translate('plan-editors/form/phone-number-label')}
                        </ControlLabel>
                        <FieldInfoIcon
                            title={Translate('popover/info/title/phonenumber')}
                            content={Translate('popover/info/content/phonenumber')}
                        />
                        <CountryCodePhoneNumberInput
                            value={props.input.phoneNumber}
                            onChange={(val) =>
                                props.onChange({
                                    target: { name: 'phoneNumber', value: val }
                                })
                            }
                        />
                        <HelpBlock>{props.errors.phoneNumber}</HelpBlock>
                    </FormGroup>
                    <LanguageSelect
                        onChange={props.onChange}
                        languageKey={props.input.languageKey}
                        errors={props.errors}
                        languages={props.availableLanguages}
                    />
                </Col>
                {props.input.profileImageReference && (
                    <Col className="profile-image-preview" md={3}>
                        <img src={`${apiUrl}/file/${props.input.profileImageReference}`} />
                    </Col>
                )}
            </Row>
        </form>
    );
};

export default PlanEditorForm;
